<template>
  <v-card class="ma-2">
    <v-card-title class="primary--text"
      >Status
      <v-divider vertical class="ml-5 mx-0"></v-divider>
    </v-card-title>

    <v-divider class="mt-n4 mx-0"> </v-divider>
    <v-card-actions></v-card-actions>
    <v-card>
      <v-data-table :headers="headers" dense :items="desserts"></v-data-table>
    </v-card>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    cardtype: "",
    headers: [
      {
        text: "SELECTED PACK",
        value: "selectedpack",
      },

      {
        text: "TRANSACTION TYPE",
        value: "type",
      },
      {
        text: "APPROVAL DATE",
        value: "date",
      },
      {
        text: "STATUS",
        value: "status",
      },
    ],
    desserts: [
      {
        selectedpack: "Pack of 10",
        status: "PENDING",
        type: "debit card",
        date: "24-03-2021",
      },
      {
        selectedpack: "Pack of 20",
        status: "PENDING",
        type: "debit card",
        date: "24-03-2021",
      },
    ],
  }),
};
</script>

<style>
</style>